import { ReactNode, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { Sidebar } from '../Sidebar';
import { MobileTopBar } from './MobileTopBar';

interface LayoutProps {
  children: ReactNode;
}

export const Layout = ({ children }: LayoutProps) => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  useEffect(() => {
    setIsSidebarOpen(false);
  }, [pathname]);

  const closeSidebar = () => setIsSidebarOpen(false);

  return (
    <div className="flex min-h-screen bg-background">
      <MobileTopBar onOpenSidebar={() => setIsSidebarOpen(true)} />

      {isSidebarOpen && (
        <button
          type="button"
          aria-label={t('sidebar.close_menu')}
          onClick={closeSidebar}
          className="fixed inset-0 z-30 bg-black bg-opacity-50 lg:hidden"
        />
      )}

      <Sidebar isOpen={isSidebarOpen} onClose={closeSidebar} />

      <main className="flex-1 min-w-0 bg-background pt-16 lg:pt-0 lg:ml-80 min-h-screen lg:h-screen">
        {children}
      </main>
    </div>
  );
};
